import request from 'api/request';

export default function readCourseRoute(courseId) {
  return request({ url: `/courses/${courseId}` });
}
